/**
 * MediaApiService.uploadFile posts every file in one multipart request, so IIS rejects on the sum,
 * not on the largest file. isFileSizeCorrect only sees one file at a time and cannot catch that:
 * three legal 20 MB images are an illegal 60 MB request, refused with a bare 413 the app never sees.
 *
 * `maxTotalSize` is decimal MB, the same convention isFileSizeCorrect uses.
 */
export const isTotalSizeCorrect = (files: File[] | FileList | null | undefined, maxTotalSize: number): boolean => {
  if (!files) {
    return true;
  }

  const total = [...files].reduce((sum, file) => sum + file.size, 0);

  return total <= maxTotalSize * 1000000;
};
